import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";
import { imageCodes, textCodes, titleCodes, videoCodes } from "../../template_codes/synergy/home_page_codes";

function Home() {
    return (

        <div>
            {/*             banner image           */}
            <div class="carousel w-full pt-2 pb-10">
                <div id="slide1" class="carousel-item relative w-full">
                    <img src={imageCodes.banner14.image} class="w-full" />
                    <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                        <a href="#slide2" class="btn btn-circle border-0">❮</a>
                        <a href="#slide2" class="btn btn-circle border-0">❯</a>
                    </div>
                </div>
                <div id="slide2" class="carousel-item relative w-full">
                    <img src={imageCodes.banner1.image} class="w-full" />
                    <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                        <a href="#slide1" class="btn btn-circle border-0">❮</a>
                        <a href="#slide1" class="btn btn-circle border-0">❯</a>
                    </div>
                </div>
            </div>
            {/*           end of banner image           */}


            {/*           about image           */}
            <div className="container w-4/5 pt-16">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-8">
                    <div className="">
                        <img src={imageCodes.aboutSynergy.image} alt="Synergy Garment" className="rounded-lg transition-transform duration-700 ..."></img>
                    </div>
                    <div className="pt-4">
                        <p className="text-md">{textCodes.est.text}</p>
                        <h1 className="font-bold text-4xl pb-8 text-gray-700">{titleCodes.synergy.title}</h1>

                        <p className="pb-4 text-gray-500">{textCodes.about1.text}</p>
                        <p className="pb-8 text-gray-500">{textCodes.about2.text}</p>

                        <Link to={paths.about}>
                            <button className="btn glass bg-black hover:bg-cyan-700 btn-sm sm:btn-sm md:btn-md lg:btn-md xl:btn-md 2xl:btn-md">
                                <p className="text-sm hover:tracking-wider px-4">View more</p>
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
            {/*           end of about image           */}

            {/*           factory process           */}
            <div className="py-20">
                <h1 className="font-bold text-3xl pb-8 text-center">{titleCodes.factory.title}</h1>
                <div class="flex px-4 items-center justify-center bg-neutral-800">
                    <div class="grid grid-cols-1 gap-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-6">
                        <div class="group relative rounded-md cursor-pointer items-center justify-center overflow-hidden transition-shadow hover:shadow-xl hover:shadow-black/30">
                            <div class="h-96 w-72">
                                <img class="h-full w-full object-cover transition-transform duration-500 group-hover:scale-125" src={imageCodes.process1.image} alt="" />
                            </div>
                            <div class="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:from-black/70 group-hover:via-black/60 group-hover:to-black/70"></div>
                            <div class="absolute inset-0 flex translate-y-[20%] flex-col items-center justify-center px-9 text-center transition-all duration-1000 group-hover:translate-y-0">
                                <h1 class="font-dmserif text-3xl font-bold text-white pb-10">{titleCodes.warehouse.title}</h1>
                                <p className="text-white">{textCodes.warehouseProcess1.text}</p>
                                <p className="text-white">{textCodes.warehouseProcess2.text}</p>
                            </div>
                        </div>

                        <div class="group relative rounded-md cursor-pointer items-center justify-center overflow-hidden transition-shadow hover:shadow-xl hover:shadow-black/30">
                            <div class="h-96 w-72">
                                <img class="h-full w-full object-cover transition-transform duration-500 group-hover:scale-125" src={imageCodes.process3.image} alt="" />
                            </div>
                            <div class="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:from-black/70 group-hover:via-black/60 group-hover:to-black/70"></div>
                            <div class="absolute inset-0 flex translate-y-[20%] flex-col items-center justify-center px-9 text-center transition-all duration-1000 group-hover:translate-y-0">
                                <h1 class="font-dmserif text-3xl font-bold text-white pb-10">{titleCodes.pattern.title}</h1>
                                <p className="text-white">{textCodes.patternProcess1.text}</p>
                            </div>
                        </div>

                        <div class="group relative rounded-md cursor-pointer items-center justify-center overflow-hidden transition-shadow hover:shadow-xl hover:shadow-black/30">
                            <div class="h-96 w-72">
                                <img class="h-full w-full object-cover transition-transform duration-500 group-hover:scale-125" src={imageCodes.process2.image} alt="" />
                            </div>
                            <div class="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:from-black/70 group-hover:via-black/60 group-hover:to-black/70"></div>
                            <div class="absolute inset-0 flex translate-y-[20%] flex-col items-center justify-center px-9 text-center transition-all duration-1000 group-hover:translate-y-0">
                                <h1 class="font-dmserif text-3xl font-bold text-white pb-10">{titleCodes.cutting.title}</h1>
                                <p className="text-white">{textCodes.cuttingProcess1.text}</p>
                                <p className="text-white">{textCodes.cuttingProcess2.text}</p>
                                <p className="text-white">{textCodes.cuttingProcess3.text}</p>
                            </div>
                        </div>

                        <div class="group relative rounded-md cursor-pointer items-center justify-center overflow-hidden transition-shadow hover:shadow-xl hover:shadow-black/30">
                            <div class="h-96 w-72">
                                <img class="h-full w-full object-cover transition-transform duration-500 group-hover:scale-125" src={imageCodes.process4.image} alt="" />
                            </div>
                            <div class="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:from-black/70 group-hover:via-black/60 group-hover:to-black/70"></div>
                            <div class="absolute inset-0 flex translate-y-[20%] flex-col items-center justify-center px-9 text-center transition-all duration-1000 group-hover:translate-y-0">
                                <h1 class="font-dmserif text-3xl font-bold text-white pb-10">{titleCodes.sewing.title}</h1>
                                <p className="text-white">{textCodes.sewingProcess1.text}</p>
                            </div>
                        </div>

                        <div class="group relative rounded-md cursor-pointer items-center justify-center overflow-hidden transition-shadow hover:shadow-xl hover:shadow-black/30">
                            <div class="h-96 w-72">
                                <img class="h-full w-full object-cover transition-transform duration-300 group-hover:scale-125" src={imageCodes.process7.image} alt="" />
                            </div>
                            <div class="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:from-black/70 group-hover:via-black/60 group-hover:to-black/70"></div>
                            <div class="absolute inset-0 flex translate-y-[20%] flex-col items-center justify-center px-9 text-center transition-all duration-1000 group-hover:translate-y-0">
                                <h1 class="font-dmserif text-3xl font-bold text-white pb-10">{titleCodes.qc.title}</h1>
                                <p className="text-white">{textCodes.qcProcess1.text}</p>
                                <p className="text-white">{textCodes.qcProcess2.text}</p>
                            </div>
                        </div>

                        <div class="group relative rounded-md cursor-pointer items-center justify-center overflow-hidden transition-shadow hover:shadow-xl hover:shadow-black/30">
                            <div class="h-96 w-72">
                                <img class="h-full w-full object-cover transition-transform duration-500 group-hover:scale-125" src={imageCodes.process6.image} alt="" />
                            </div>
                            <div class="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black group-hover:from-black/70 group-hover:via-black/60 group-hover:to-black/70"></div>
                            <div class="absolute inset-0 flex translate-y-[20%] flex-col items-center justify-center px-9 text-center transition-all duration-1000 group-hover:translate-y-0">
                                <h1 class="font-dmserif text-3xl font-bold text-white pb-10">{titleCodes.finishing.title}</h1>
                                <p className="text-white">{textCodes.finishingProcess1.text}</p>
                                <p className="text-white">{textCodes.finishingProcess2.text}</p>
                                <p className="text-white">{textCodes.finishingProcess3.text}</p>
                                <p className="text-white">{textCodes.finishingProcess4.text}</p>
                                <p className="text-white">{textCodes.finishingProcess5.text}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*           end of factory process           */}


            {/*           client's logo           */}
            <div className="container w-4/5 py-8">
                <p className="text-sm text-center">{textCodes.clients.text}</p>
                <h1 className="font-bold text-3xl pb-8 text-center">{titleCodes.clientTitle.title}</h1>

                <div className="grid grid-cols-4 gap-0">
                    <div className="p-2">
                        <img src={imageCodes.client1.image} alt="Client Logo" width={106} height={86} className="rounded-md hover:opacity-75 ..." />
                    </div>
                    <div className="p-2">
                        <img src={imageCodes.client2.image} alt="Client Logo" width={106} height={86} className="rounded-md hover:opacity-75 ..." />
                    </div>
                    <div className="p-2">
                        <img src={imageCodes.client3.image} alt="Client Logo" width={106} height={86} className="rounded-md hover:opacity-75 ..." />
                    </div>
                    <div className="p-2">
                        <img src={imageCodes.client5.image} alt="Client Logo" width={116} height={106} className="rounded-md hover:opacity-75 ..." />
                    </div>
                </div>
            </div>
            {/*           end of client's logo           */}

            {/*           get in touch           */}
            <div className="container w-4/5 py-20">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-8">
                    <div className="">
                        <embed src={videoCodes.video1.video} title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
                            className="w-full h-64 md:h-80 lg:h-80 xl:h-96 2xl:h-96">
                        </embed>
                    </div>
                    <div className="pl-4">
                        <h1 className="font-bold text-4xl pb-4 text-gray-700">Market & Customers</h1>

                        <h1 className="text-cyan-900 font-semibold text-xl pt-4">Europe :</h1>
                        <ul className="list-none">
                            <li><p className="text-gray-500">UK (AUCHEN, GEMO)</p></li>
                            <li><p className="text-gray-500">BELGIUM (AUCHEN, GEMO)</p></li>
                            <li><p className="text-gray-500">FRANCE (AUCHEN, GEMO)</p></li>
                        </ul>

                        <h1 className="text-cyan-900 font-semibold text-xl pt-4">Asia :</h1>
                        <ul className="list-none">
                            <li><p className="text-gray-500">KOREA (E-Mart, TBJ, Tesco)</p></li>
                            <li><p className="text-gray-500">Morocco (AUCHEN)</p></li>
                        </ul>
                        <Link to={paths.contact}>
                            <button className="btn glass bg-black hover:bg-cyan-700 btn-sm sm:btn-sm md:btn-md lg:btn-md xl:btn-md 2xl:btn-md mt-4">
                                <p className="text-sm hover:tracking-wider px-4">Contact us</p>
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
            {/*           end of get in touch           */}
        </div >
    );
}

export default Home;



